var REMOTE_RESOURCE_PATTERN = /^(\w+:\/\/|\/\/)/;

function isRemoteResource(uri) {
  return REMOTE_RESOURCE_PATTERN.test(uri);
}

module.exports = isRemoteResource;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/utils/is-remote-resource.js
// module id = 191
// module chunks = 0